import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../styles.css';

const Stake = () => {
  const [amount, setAmount] = useState('');
  const [duration, setDuration] = useState('');
  const [stakeResult, setStakeResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const stakingOptions = [3, 6, 9, 12, 15, 18, 21, 24];

  const handleStakeSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStakeResult(null);
    const token = localStorage.getItem('token');
    if (!token) {
      setError('Please login first');
      navigate('/login');
      return;
    }

    const parsedAmount = Number(amount);
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      setError('Please enter a valid positive amount of ABAY tokens to stake.');
      return;
    }
    if (!duration) {
      setError('Please select a staking duration.');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/stake`,
        { amount: parsedAmount, duration_months: Number(duration) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStakeResult(res.data);
      setAmount('');
      setDuration('');
    } catch (err) {
      setError(err.response?.data?.error || 'An unknown error occurred during staking');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <Header />
      <section className="content-container container my-4">
        <h1 className="text-center mb-4">Stake ABAY Tokens</h1>
        <div className="card p-4 mx-auto card-mid-width">
        <form onSubmit={handleStakeSubmit} className="card p-4 mx-auto card-mid-width">
          <h2 className="card-title text-center">Enter Staking Details</h2>
          <div className="mb-3">
            <input
              type="number"
              className="form-control"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Amount of ABAY Tokens"
              required
              min="0.01"
              step="0.01"
            />
          </div>
          <div className="mb-3">
            <select
              className="form-control"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              required
            >
              <option value="">Select Staking Duration</option>
              {stakingOptions.map((months) => (
                <option key={months} value={months}>{months} Months</option>
              ))}
            </select>
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? 'Staking...' : 'Stake Tokens'}
          </button>
          {error && <p className="text-danger mt-3 text-center">{error}</p>}
        </form>
        {stakeResult && (
          <div className="card p-4 mx-auto card-max-width">
            <div className="card-body">
              <h3 className="card-title">Staking Confirmation</h3>
              <p>Amount Staked: {stakeResult.amount} ABAY</p>
              <p>Duration: {stakeResult.duration_months} Months</p>
              <p>Stake ID: {stakeResult.stake_id}</p>
            </div>
          </div>
        )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Stake;
